import { createContext } from 'react';
export const defaultConfig = {
  linkComponent: 'a'
};
export const ConfigContext = /*#__PURE__*/createContext(defaultConfig);